export default "__VITE_ASSET__JC_8zuPf__"